import { setTokensPersistence } from "../../actions";
import { createReducer } from '@reduxjs/toolkit';
export const createTokensPersistenceReducer = initialState => createReducer(initialState, b => {
  b.addCase(setTokensPersistence, (_, action) => action.payload);
});